import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import $ from 'jquery';
import { useForm } from 'react-hook-form';
import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  AddCarSaleListing,
  EditCarSaleListing,
  AddMedia,
  getCarBrand,
  getCarModels,
  getCarModelYear,
  getCarCylinder,
  getCarFuelType,
  getCarSeat,
  getCarDoor,
  getCarColor,
  getCarSafety,
  getCarComfort,
  getPlansListing,
  PayForCarSale,
} from './../../../../Redux/Actions/UserAction';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { sanitizeWhatsAppFields } from '../../../../utils/sanitizeWhatsApp';

// const API = 'https://api.carsavenue.com/api';
const API = 'https://api.carsavenue.com/api';

const config = () => ({
  headers: {
    'Content-Type': 'multipart/form-data',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
});

export default function CarForSale() {
  const { t, i18n } = useTranslation();

  // Render the right label for the active language: English field for English,
  // Arabic (`*Ar`) field for Arabic, with a fallback to whichever exists.
  const lang = (i18n.language || 'en').toLowerCase().startsWith('ar')
    ? 'ar'
    : 'en';
  const L = (en, ar) => (lang === 'ar' ? ar || en : en || ar);

  // Numeric option lists must be sorted (the API returns them unordered).
  const sortNum = (arr, key, desc) =>
    Array.isArray(arr)
      ? [...arr].sort((a, b) =>
          desc
            ? Number(b[key]) - Number(a[key])
            : Number(a[key]) - Number(b[key])
        )
      : [];

  const dispatch = useDispatch();
  const home = useSelector((state) => state?.home);

  const CarBrand = home?.garageCarBrandList;
  // Brand-linked car models for the model dropdown (falls back to free text).
  const CarModels = home?.carModels;
  const CarModelYear = home?.CarModelYears;
  const CarCylinder = home?.CarCylinders;
  const CarFuelType = home?.CarFuelTypes;
  const CarSeat = home?.CarSeats;
  const CarDoor = home?.CarDoors;
  const CarColor = home?.CarColors;
  const CarSafety = home?.CarSafety;
  const CarComfort = home?.CarComfort;

  // Packages for publishing a car for sale (global plans, businessCode = null).
  const allPlans = home?.getAllPlansList;
  const planList = allPlans
    ? Object.keys(allPlans).map((key) => allPlans[key])
    : [];
  // The carSaleId returned after the car record is created — drives the
  // "choose a package & pay to publish" step.
  const [createdCarSaleId, setCreatedCarSaleId] = useState('');

  const {
    register,
    trigger,
    setValue,
    formState: { errors },
  } = useForm({ mode: 'all' });

  const [CarSaleData, setCarSaleData] = useState({
    carBrandId: '',
    carModel: '',
    price: '',
    description: '',
    // [CF] Default to +965 — the backend requires mobileNumberCountryCode, and
    // leaving the dropdown on its placeholder sent it empty → submit rejected.
    mobileNumberCountryCode: '+965',
    mobileNumber: '',
    mobileNumbers: [
      {
        countryCode: '+965',
        mobileNumber: '',
      },
    ],
    cyclinderId: '',
    kilometerDriven: '',
    modelYearId: '',
    fuelTypeId: '',
    doorId: '',
    seatId: '',
    interiorColorId: '',
    exteriorColorId: '',
  });

  useEffect(() => {
    dispatch(getCarBrand());
    dispatch(getCarModelYear());
    dispatch(getCarCylinder());
    dispatch(getCarFuelType());
    dispatch(getCarSeat());
    dispatch(getCarDoor());
    dispatch(getCarColor());
    dispatch(getCarSafety());
    dispatch(getCarComfort());
    dispatch(getPlansListing());
  }, []);

  // Load brand-linked car models whenever the selected brand changes.
  useEffect(() => {
    if (CarSaleData.carBrandId) {
      dispatch(getCarModels(CarSaleData.carBrandId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [CarSaleData.carBrandId]);

  const [Safety, setSafety] = useState([]);
  const [Comfort, setComforty] = useState([]);

  // Edit mode: My Posts links here as /sp-cars-for-sale?edit=<carSaleId>.
  const editId = new URLSearchParams(
    (window.location.hash.split('?')[1] || '')
  ).get('edit');


  useEffect(() => {
    if (!editId) return;
    axios
      .get(API + `/carSale/listing?carSaleId=${editId}`, {
        headers: { Authorization: sessionStorage.getItem('loged_In_auth') },
      })
      .then((res) => {
        const car = res?.data?.response?.data?.[0];
        if (!car) return;
        // [FB2-#3] Phone may come back top-level OR nested under mobileNumbers[].
        const phone0 = car.mobileNumbers?.[0] || {};
        const phone1 = car.mobileNumbers?.[1] || {};
        const mobileNumber = car.mobileNumber || phone0.mobileNumber || '';
        const mobileNumberCountryCode =
          car.mobileNumberCountryCode || phone0.countryCode || '';
        const whatsAppNumber = car.whatsAppNumber || phone1.mobileNumber || '';
        const whatsAppNumberCountryCode =
          car.whatsAppNumberCountryCode || phone1.countryCode || '';
        setCarSaleData((prev) => ({
          ...prev,
          carBrandId: car.carBrandId || '',
          carModel: car.carModel || '',
          price: car.price ?? '',
          description: car.description || '',
          mobileNumberCountryCode,
          mobileNumber,
          whatsAppNumberCountryCode,
          whatsAppNumber,
          cyclinderId: car.cyclinderId || '',
          kilometerDriven: car.kilometerDriven || '',
          modelYearId: car.modelYearId || '',
          fuelTypeId: car.fuelTypeId || '',
          doorId: car.doorId || '',
          seatId: car.seatId || '',
          interiorColorId: car.interiorColorId || '',
          exteriorColorId: car.exteriorColorId || '',
        }));
        setSafety((car.safetyId || []).map((s) => s.safetyId).filter(Boolean));
        setComforty(
          (car.comfortId || []).map((c) => c.comfortId).filter(Boolean)
        );
        // [CF] Load the saved images as removable previews (with their mediaIds)
        // so the owner can delete specific ones — not just append new uploads.
        const savedMedia = (car.businessMedia || []).filter(
          (m) => m?.media?.mediaId && m?.media?.path
        );
        setImageBlob(savedMedia.map((m) => m.media.path));
        setEditMediaIds(savedMedia.map((m) => m.media.mediaId));
        setFile([]);
        setSelectedForDelete([]);
        setPrimaryIndex(0); // saved cover is already first
        // [FB2-#3] RHF only tracks values entered through its own onChange. The
        // phone input spreads {...register('mobileNumber')} but overrides its
        // onChange, so a prefilled number never reaches RHF and submit-time
        // trigger() fails "required" even though the field is visibly filled.
        // Sync RHF here so editing a car doesn't force re-typing the phone.
        setValue('mobileNumber', mobileNumber, { shouldValidate: true });
        setValue('whatsAppNumber', whatsAppNumber, { shouldValidate: true });
      })
      .catch(() => {});
  }, [editId]);

  const handleSafetyChange = (event) => {
    var checkedItem = event.target.value;
    let newArray = [...Safety, checkedItem];
    if (Safety.includes(checkedItem)) {
      newArray = newArray.filter((safe) => safe !== checkedItem);
    }
    setSafety(newArray);
  };

  const handleComfortChange = (event) => {
    var checkedItem = event.target.value;
    let newArray = [...Comfort, checkedItem];
    if (Comfort.includes(checkedItem)) {
      newArray = newArray.filter((comf) => comf !== checkedItem);
    }
    setComforty(newArray);
  };

  function handleChange(e) {
    const { name, value } = e.target;
    setCarSaleData((user) => ({ ...user, [name]: value }));
    // Clear this field's inline error as soon as the user starts fixing it.
    setFieldErrors((prev) => (prev[name] ? { ...prev, [name]: '' } : prev));
  }

  const [File, setFile] = useState([]);

  const [ImageBlob, setImageBlob] = useState([]);

  // On edit, the mediaIds of the post's already-saved images, kept in the same
  // order as the LEADING entries of ImageBlob. Newly-added (not-yet-uploaded)
  // images come after these. Sending the COMPLETE final set lets the backend
  // replace (not append) the post's images, so removals actually take effect.
  const [editMediaIds, setEditMediaIds] = useState([]);

  // [CF] Image multi-select: blob indices the owner ticked for bulk deletion.
  const [selectedForDelete, setSelectedForDelete] = useState([]);

  // [FB2-#8] Which image is the PRIMARY/cover (ImageBlob index). Sent first in
  // the mediaIds array so the backend treats it as the cover (priority 0).
  const [primaryIndex, setPrimaryIndex] = useState(0);

  // [CF] Inline validation messages shown UNDER each field, instead of one
  // blocking popup at a time. Cleared as the user edits.
  const [fieldErrors, setFieldErrors] = useState({});

  // Render a field's inline error message (red, under the field) if present.
  const renderFieldError = (key) =>
    fieldErrors[key] ? (
      <div
        style={{ color: '#dc3545', fontSize: '0.85rem', marginTop: '4px' }}
      >
        {fieldErrors[key]}
      </div>
    ) : null;

  console.log('ImageBlob', ImageBlob);
  console.log('File', File);

  const toggleSelectForDelete = (index) => {
    setSelectedForDelete((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handleRemoveClick = (index) => {
    const existingCount = editMediaIds.length;
    setImageBlob((prev) => prev.filter((_, i) => i !== index));

    if (index < existingCount) {
      // Removing an already-saved image -> drop its mediaId from the kept set.
      setEditMediaIds((prev) => prev.filter((_, i) => i !== index));
    } else {
      // Removing a newly-added image -> drop the corresponding File.
      setFile((prev) => prev.filter((_, fi) => fi !== index - existingCount));
    }

    setSelectedForDelete((prev) =>
      prev.filter((i) => i !== index).map((i) => (i > index ? i - 1 : i))
    );

    // [FB2-#8] Keep the primary pointing at the same image after a removal.
    setPrimaryIndex((prev) => {
      if (index === prev) return 0; // removed the primary -> fall back to first
      return index < prev ? prev - 1 : prev;
    });
  };

  // [CF] Bulk-delete every ticked thumbnail in one pass. ImageBlob is ordered
  // [existing..., new...]: existing map to editMediaIds[i], new map to
  // File[i - existingCount].
  const handleDeleteSelected = () => {
    if (!selectedForDelete.length) return;
    const toRemove = new Set(selectedForDelete);
    const existingCount = editMediaIds.length;
    setImageBlob((prev) => prev.filter((_, i) => !toRemove.has(i)));
    setEditMediaIds((prev) => prev.filter((_, i) => !toRemove.has(i)));
    setFile((prev) => prev.filter((_, fi) => !toRemove.has(fi + existingCount)));
    setSelectedForDelete([]);
    // [FB2-#8] Recompute the primary after a bulk removal: if it was deleted,
    // fall back to the first remaining image; otherwise shift it down by the
    // number of removed images that sat before it.
    setPrimaryIndex((prev) => {
      if (toRemove.has(prev)) return 0;
      const removedBefore = [...toRemove].filter((i) => i < prev).length;
      return prev - removedBefore;
    });
  };

  const handleUploadImage = (event) => {
    // Bulk upload: process EVERY selected file (was files[0] only), appending
    // each to the File array and generating a preview for each.
    const files = Array.from(event.target.files || []);
    if (!files.length) return;

    setFile((prev) => [...prev, ...files]);
    files.forEach((file) => {
      const reader = new FileReader(file);
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setImageBlob((prev) => [...prev, reader.result]);
      };
    });
    // Clear the "upload an image" inline error now that one was added.
    setFieldErrors((prev) => (prev.image ? { ...prev, image: '' } : prev));

    // Reset so re-selecting the same files re-triggers onChange.
    event.target.value = '';
  };

  useEffect(() => {
    setCarSaleData({
      ...CarSaleData,
      mobileNumbers: [
        {
          countryCode: CarSaleData.mobileNumberCountryCode,
          mobileNumber: CarSaleData.mobileNumber,
        },
        {
          countryCode: CarSaleData.whatsAppNumberCountryCode,
          mobileNumber: CarSaleData.whatsAppNumber,
        },
      ],
    });
  }, [
    CarSaleData.mobileNumberCountryCode,
    CarSaleData.mobileNumber,
    CarSaleData.whatsAppNumberCountryCode,
    CarSaleData.whatsAppNumber,
  ]);

  // Empty dropdowns post '' which is an invalid UUID for the FK columns and
  // makes the backend reject the whole car. Convert blanks to null so optional
  // fields are simply omitted. (description stays as-is — it's plain text.)
  const clean = (obj) => {
    const out = {};
    Object.keys(obj).forEach((k) => {
      out[k] = obj[k] === '' ? null : obj[k];
    });
    return out;
  };

  // [FB2-#8] Move the chosen primary image to the front of the mediaIds array
  // so the backend stores it as the cover (priority 0 / first image).
  const reorderPrimaryFirst = (mediaIds) => {
    if (
      !Array.isArray(mediaIds) ||
      primaryIndex <= 0 ||
      primaryIndex >= mediaIds.length
    )
      return mediaIds;
    const arr = [...mediaIds];
    const [primary] = arr.splice(primaryIndex, 1);
    arr.unshift(primary);
    return arr;
  };

  // Guard against double-submit (a fast second click would post a duplicate car).
  const submittingRef = useRef(false);

  // Build the car payload. The backend requires a non-empty carName, but this
  // form has no name field — derive one from brand + model + year.
  const buildCarData = (mediaIds) => {
    const brandObj = (CarBrand || []).find(
      (b) => b.brandId === CarSaleData.carBrandId
    );
    const yearObj = (CarModelYear || []).find(
      (y) => y.modelYearId === CarSaleData.modelYearId
    );
    const carName =
      [brandObj?.name || brandObj?.nameAr, CarSaleData.carModel, yearObj?.modelYear]
        .filter(Boolean)
        .join(' ') || 'Car';

    const DATA = {
      ...clean(CarSaleData),
      carName,
      safetyId: Safety,
      comfortId: Comfort,
    };
    if (mediaIds && mediaIds.length) {
      DATA.mediaIds = { CAR_IMAGE: mediaIds };
    }
    if (editId) {
      DATA.carSaleId = editId;
    }
    return DATA;
  };

  // [CF] Open/close the package modal in a Bootstrap-version-safe way. This app
  // uses Bootstrap 5 (no jQuery `.modal`), so `$('#x').modal('show')` THREW —
  // and because that ran inside the create-success handler, the throw bubbled to
  // the catch and showed "A problem occurred" even though the car WAS created.
  const showPackageModal = () => {
    const el = document.getElementById('carsale-package-modal');
    if (!el) return;
    try {
      // eslint-disable-next-line global-require
      const { Modal } = require('bootstrap');
      (Modal.getInstance(el) || Modal.getOrCreateInstance(el)).show();
      return;
    } catch (e) {}
    try {
      if (window.$ && window.$(el).modal) {
        window.$(el).modal('show');
        return;
      }
    } catch (e) {}
    el.classList.add('show');
    el.style.display = 'block';
    el.removeAttribute('aria-hidden');
    document.body.classList.add('modal-open');
  };
  const hidePackageModal = () => {
    const el = document.getElementById('carsale-package-modal');
    if (!el) return;
    try {
      // eslint-disable-next-line global-require
      const { Modal } = require('bootstrap');
      (Modal.getInstance(el) || Modal.getOrCreateInstance(el)).hide();
    } catch (e) {}
    try {
      if (window.$ && window.$(el).modal) window.$(el).modal('hide');
    } catch (e) {}
    el.classList.remove('show');
    el.style.display = 'none';
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
    document.querySelectorAll('.modal-backdrop').forEach((b) => b.remove());
  };

  const dispatchCar = (mediaIds) => {
    const _payload = sanitizeWhatsAppFields(buildCarData(mediaIds));
    if (editId) {
      dispatch(EditCarSaleListing(_payload));
    } else {
      // New car: create the record, then open package selection. The car is
      // only published once a package is chosen and paid for.
      dispatch(
        AddCarSaleListing(_payload, (newId) => {
          setCreatedCarSaleId(newId);
          Swal.close(); // [FB2-#16] close the "Publishing…" loader
          showPackageModal();
        })
      );
    }
  };

  // Pay for / publish the freshly-created car with the chosen package.
  const onChoosePackage = (plan) => {
    const packId = plan?.advertisementPackId;
    if (!packId || !createdCarSaleId) return;
    hidePackageModal();
    // [CF] The pay-car-sale POST takes several seconds to create the Tap charge
    // before redirecting to KNET. Show a blocking loader so the wait is clear
    // (previously the screen just sat there with no feedback for 5-10s).
    Swal.fire({
      title: t('Redirecting to payment…'),
      text: t('Please wait, do not close this window.'),
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => Swal.showLoading(),
    });
    dispatch(
      PayForCarSale({ paymentPlan: packId, carSaleId: createdCarSaleId })
    );
  };

  const UploadImage = (event) => {
    // Existing images the owner kept (set in the edit prefill, minus any they
    // removed/multi-deleted) + any newly-uploaded files = the FINAL image set.
    const keptExisting = (editMediaIds || []).filter(Boolean);
    const hasNew = File && File.length > 0;
    const hasExisting = keptExisting.length > 0;

    if (!hasNew && !hasExisting) {
      Swal.fire({
        title: 'Please upload at least one car image',
        icon: 'warning',
      });
      return;
    }

    if (submittingRef.current) return;
    submittingRef.current = true;

    // [FB2-#16] Creating the car + uploading images takes several seconds. Show
    // a blocking loading spinner (the "appropriate loading icon") so the screen
    // isn't just frozen. It's closed when the package modal opens (create path),
    // or replaced by the success/error alert (edit path / failures).
    Swal.fire({
      title: editId ? t('Saving…') : t('Publishing your car…'),
      text: t('Please wait, do not close this window.'),
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => Swal.showLoading(),
    });

    // No new uploads — send the kept existing set so removals actually replace
    // the post's images (a field-only edit just re-sends the same set).
    if (!hasNew) {
      dispatchCar(reorderPrimaryFirst(keptExisting));
      submittingRef.current = false;
      return;
    }

    const formData = new FormData();
    File.forEach((file) => {
      formData.append('media', file);
    });

    axios
      .post(API + '/media/new', formData, config())
      .then((res) => {
        submittingRef.current = false;
        const newIds = [
          ...new Set(res.data.response.media.map((d) => d.mediaId)),
        ];
        dispatchCar(reorderPrimaryFirst([...keptExisting, ...newIds]));
      })
      .catch((err) => {
        submittingRef.current = false;
        Swal.fire({
          title:
            err?.response?.data?.response?.message ||
            err?.response?.data?.message ||
            'Image upload failed. Please try again.',
          icon: 'error',
        });
      });
  };

  // Validate the non-RHF fields and set their inline messages. Returns true when
  // all are valid.
  const validateOwnFields = () => {
    const errs = {};
    if (!CarSaleData.carBrandId) {
      errs.carBrandId = t('Please select a Car Brand');
    }
    if (!CarSaleData.carModel || !String(CarSaleData.carModel).trim()) {
      errs.carModel = t('Please enter the Car Model and Series');
    }
    if (
      CarSaleData.price === '' ||
      CarSaleData.price === null ||
      CarSaleData.price === undefined ||
      Number(CarSaleData.price) <= 0
    ) {
      errs.price = t('Please enter a valid Price');
    }
    if (!CarSaleData.modelYearId) {
      errs.modelYearId = t('Please select the Model Year');
    }
    if (!CarSaleData.cyclinderId) {
      errs.cyclinderId = t('Please select the Cylinder type');
    }
    if (
      !CarSaleData.kilometerDriven ||
      !String(CarSaleData.kilometerDriven).trim()
    ) {
      errs.kilometerDriven = t('Please enter the Kilometer Driven');
    }
    if (!CarSaleData.fuelTypeId) {
      errs.fuelTypeId = t('Please select the Fuel Type');
    }
    if (!CarSaleData.doorId) {
      errs.doorId = t('Please select the number of Doors');
    }
    if (!CarSaleData.seatId) {
      errs.seatId = t('Please select the number of Seats');
    }
    // Colors are now required on the website too (the iOS app already forces
    // them) so cars can't be saved without a colour.
    if (!CarSaleData.interiorColorId) {
      errs.interiorColorId = t('Please select the Interior Color');
    }
    if (!CarSaleData.exteriorColorId) {
      errs.exteriorColorId = t('Please select the Exterior Color');
    }
    const hasImage =
      (editMediaIds || []).filter(Boolean).length > 0 ||
      (File && File.length > 0);
    if (!hasImage) {
      errs.image = t('Please upload at least one car image');
    }
    setFieldErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const datasubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    // [CF] Validate the react-hook-form fields (phone, kilometer) AND the custom
    // fields (brand/model/price/year/image) TOGETHER, so EVERY missing field is
    // flagged at once on the first submit — instead of being revealed one layer
    // at a time (RHF used to gate and hide the rest).
    const rhfValid = await trigger();
    const ownValid = validateOwnFields();
    if (!rhfValid || !ownValid) return;
    UploadImage();
  };

  return (
    <div>
      <div class="main-content-area">
        <div class="container">
          <div class="sp-cfs-wrap">
            <h4 class="mb-4">
              {editId ? t('Edit Car for Sale') : t('Start adding the car')}
            </h4>
            <form onSubmit={datasubmit}>
              <div class="form-group">
                <label for="anc-car-brand">{t('Select Car Brand')} <span style={{ color: '#dc3545' }}>*</span></label>
                <select
                  class="form-control"
                  id="anc-car-brand"
                  name="carBrandId"
                  value={CarSaleData.carBrandId}
                  onChange={handleChange}
                >
                  <option> - {t('Select Car Brand')} - </option>
                  {CarBrand !== undefined && CarBrand.length
                    ? CarBrand.map((brand, idx) => (
                        <option value={brand.brandId}>
                          {L(brand.name, brand.nameAr)}
                        </option>
                      ))
                    : null}
                </select>
                {fieldErrors.carBrandId && (
                  <div
                    style={{
                      color: '#dc3545',
                      fontSize: '0.85rem',
                      marginTop: '4px',
                    }}
                  >
                    {fieldErrors.carBrandId}
                  </div>
                )}
              </div>

              <div class="form-group">
                <label for="anc-car-model">{t('Car Model and Series')} <span style={{ color: '#dc3545' }}>*</span></label>
                {Array.isArray(CarModels) && CarModels.length ? (
                  <select
                    class="form-control"
                    id="anc-car-model"
                    name="carModel"
                    value={CarSaleData.carModel}
                    onChange={handleChange}
                  >
                    <option value=""> - {t('Select Car Model')} - </option>
                    {CarModels.map((model, idx) => (
                      <option key={idx} value={model.name}>
                        {L(model.name, model.nameAr)}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    class="form-control"
                    name="carModel"
                    type="text"
                    value={CarSaleData.carModel}
                    onChange={handleChange}
                    placeholder={t('Enter car model and series')}
                  />
                )}
                {fieldErrors.carModel && (
                  <div
                    style={{
                      color: '#dc3545',
                      fontSize: '0.85rem',
                      marginTop: '4px',
                    }}
                  >
                    {fieldErrors.carModel}
                  </div>
                )}
              </div>

              <div class="form-group">
                <label for="anc-car-model">{t('Car Price')} <span style={{ color: '#dc3545' }}>*</span></label>
                <input
                  class="form-control"
                  name="price"
                  type="number"
                  value={CarSaleData.price}
                  onChange={handleChange}
                  placeholder={t('Price')}
                />
                {fieldErrors.price && (
                  <div
                    style={{
                      color: '#dc3545',
                      fontSize: '0.85rem',
                      marginTop: '4px',
                    }}
                  >
                    {fieldErrors.price}
                  </div>
                )}
              </div>

              <div class="btn btn-primary btn-file">
                <label class="btn text-white upload-button btn-sm" for="files">
                  <i class="fas fa-folder-open"></i> &nbsp;{' '}
                  {t('Upload your Car Images')} <span style={{ color: '#dc3545' }}>*</span> …
                </label>
                <input
                  type="file"
                  id="files"
                  accept="image/*"
                  multiple
                  onChange={handleUploadImage}
                  style={{ display: 'none' }}
                />
                {/* <input type='file' multiple='multiple' id='file-3' /> */}
              </div>
              {fieldErrors.image && (
                <div
                  style={{
                    color: '#dc3545',
                    fontSize: '0.85rem',
                    marginTop: '4px',
                  }}
                >
                  {fieldErrors.image}
                </div>
              )}

              {/* <div class='form-group'>
								<label>Upload your Car Images</label>
								<input type='file' multiple='multiple' id='file-3' />
							</div> */}

              {/* [CF] Bulk image actions: appears once one or more thumbnails are
                  ticked. Delete several images (existing or new) at once. */}
              {ImageBlob.length > 0 && (
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <small className="text-muted">
                    {selectedForDelete.length > 0
                      ? `${selectedForDelete.length} ${t('selected')}`
                      : t('Tick images to delete multiple at once')}
                  </small>
                  {selectedForDelete.length > 0 && (
                    <button
                      type="button"
                      class="btn btn-sm btn-danger"
                      onClick={handleDeleteSelected}
                    >
                      <i class="far fa-trash-alt"></i>{' '}
                      {t('Delete selected')} ({selectedForDelete.length})
                    </button>
                  )}
                </div>
              )}

              <div class="form-group">
                {/* <label>Business Logo Image</label> */}
                <div class="row align-items-center ">
                  {ImageBlob.map((item, indexValue) => {
                    const isChecked = selectedForDelete.includes(indexValue);
                    const isPrimary = indexValue === primaryIndex;
                    return (
                      <div class="col-auto">
                        <div
                          class=" row-cols-7"
                          style={{
                            border: isChecked
                              ? '2px solid #dc3545'
                              : isPrimary
                              ? '2px solid #ffc107'
                              : '2px solid transparent',
                            borderRadius: '6px',
                            padding: '2px',
                          }}
                        >
                          <div class="d-flex align-items-center justify-content-between">
                            <label
                              class="m-0"
                              style={{
                                fontSize: '0.7rem',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={() =>
                                  toggleSelectForDelete(indexValue)
                                }
                              />
                              {t('Select')}
                            </label>
                            <button
                              type="button"
                              class="close"
                              aria-label="Close"
                              onClick={() => handleRemoveClick(indexValue)}
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <img
                            style={{
                              height: '5rem',
                              width: '8rem',
                            }}
                            class="profile-pic img-fluid m-1"
                            src={
                              item !== undefined
                                ? item
                                : 'assets/images/camera.jpg'
                            }
                            alt=""
                          />
                          {/* [FB2-#8] Primary/cover image selector. */}
                          <div class="text-center">
                            {isPrimary ? (
                              <span
                                style={{
                                  color: '#d39e00',
                                  fontSize: '0.72rem',
                                  fontWeight: 600,
                                }}
                              >
                                <i class="fas fa-star"></i> {t('Primary')}
                              </span>
                            ) : (
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-warning py-0"
                                style={{ fontSize: '0.7rem' }}
                                onClick={() => setPrimaryIndex(indexValue)}
                              >
                                {t('Set as primary')}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* <div class='form-group'>
								<label>Upload your Car Images</label>
								<input type='file' multiple='multiple' id='file-3' />
							</div> */}

              <div class="form-group">
                <label for="anc-description">
                  {t('Car Description')} <small>({t('Optional')})</small>
                </label>
                <textarea
                  name="description"
                  value={CarSaleData.description}
                  onChange={handleChange}
                  class="form-control"
                  id="anc-description"
                  rows="6"
                  maxLength={4000}
                ></textarea>
              </div>

              <div class="form-group">
                <label for="anc-phone-number">{t('Phone Number')} <span style={{ color: '#dc3545' }}>*</span></label>
                <div class="row">
                  <div class="col-4">
                    <select
                      class="form-control"
                      name="mobileNumberCountryCode"
                      value={CarSaleData.mobileNumberCountryCode}
                      onChange={handleChange}
                    >
                      <option>{t('Country Code')}</option>
                      <option>+965</option>
                    </select>
                  </div>
                  <div class="col-8">
                    <input
                      {...register('mobileNumber', {
                        required: t('This field is required'),
                        pattern: {
                          value: /^\d{8}$/,
                          message: 'please enter a valid 8-digit phone number',
                        },
                      })}
                      name="mobileNumber"
                      value={CarSaleData.mobileNumber}
                      onChange={handleChange}
                      type="tel"
                      className={classNames('form-control', {
                        'is-invalid': errors.mobileNumber,
                      })}
                      id="g-mb-phone-number"
                      placeholder={t('Phone Number')}
                    />
                    {errors.mobileNumber && (
                      <p className="invalid-feedback">
                        {errors.mobileNumber.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="anc-wsup-number">
                  {t('WhatsApp Number')} <small>({t('Optional')})</small>
                </label>
                <div class="row">
                  <div class="col-4">
                    <select
                      class="form-control"
                      name="whatsAppNumberCountryCode"
                      value={CarSaleData.whatsAppNumberCountryCode}
                      onChange={handleChange}
                    >
                      <option>{t('Country Code')}</option>
                      <option>+965</option>
                    </select>
                  </div>
                  <div class="col-8">
                    <input
                      {...register('whatsAppNumber', {
                        pattern: {
                          value: /^\d{8}$/,
                          message: 'please enter a valid 8-digit phone number',
                        },
                      })}
                      name="whatsAppNumber"
                      value={CarSaleData.whatsAppNumber}
                      onChange={handleChange}
                      type="tel"
                      className={classNames('form-control', {
                        'is-invalid': errors.whatsAppNumber,
                      })}
                      id="g-mb-whatsApp-number"
                      placeholder={t("WhatsApp Number")}
                    />
                    {errors.whatsAppNumber && (
                      <p className="invalid-feedback">
                        {errors.whatsAppNumber.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="anc-cyclinder">{t('Cyclinder')} <span style={{ color: '#dc3545' }}>*</span></label>
                <select
                  class="form-control"
                  id="anc-cyclinder"
                  name="cyclinderId"
                  value={CarSaleData.cyclinderId}
                  onChange={handleChange}
                >
                  <option> - {t('Select Cyclinder Type')} - </option>
                  {sortNum(CarCylinder, 'cyclinder').map((cylinder, idx) => (
                    <option value={cylinder.cyclinderId}>
                      {cylinder.cyclinder}
                    </option>
                  ))}
                </select>
                {renderFieldError('cyclinderId')}
              </div>

              <div class="form-group">
                <label for="anc-kilometer-driven">
                  {t('Kilometer Driven')} <span style={{ color: '#dc3545' }}>*</span>
                </label>
                <input
                  name="kilometerDriven"
                  value={CarSaleData.kilometerDriven}
                  onChange={handleChange}
                  type="text"
                  class="form-control"
                  id="anc-kilometer-driven"
                  placeholder={t('Kilometer Driven')}
                />
                {renderFieldError('kilometerDriven')}
              </div>

              <div class="form-group">
                <label for="anc-model-year">{t('Model Year')} <span style={{ color: '#dc3545' }}>*</span></label>
                <select
                  class="form-control"
                  id="anc-model-year"
                  name="modelYearId"
                  value={CarSaleData.modelYearId}
                  onChange={handleChange}
                >
                  <option> - {t('Select Model Year')} - </option>
                  {sortNum(CarModelYear, 'modelYear', true).map((year, idx) => (
                    <option value={year.modelYearId}>{year.modelYear}</option>
                  ))}
                </select>
                {fieldErrors.modelYearId && (
                  <div
                    style={{
                      color: '#dc3545',
                      fontSize: '0.85rem',
                      marginTop: '4px',
                    }}
                  >
                    {fieldErrors.modelYearId}
                  </div>
                )}
              </div>

              <div class="form-group">
                <label for="anc-fuel-type">{t('Fuel Type')} <span style={{ color: '#dc3545' }}>*</span></label>
                <select
                  class="form-control"
                  id="anc-fuel-type"
                  name="fuelTypeId"
                  value={CarSaleData.fuelTypeId}
                  onChange={handleChange}
                >
                  <option> - {t('Select Fuel Type')} - </option>
                  {CarFuelType !== undefined && CarFuelType.length
                    ? CarFuelType.map((fuel, idx) => (
                        <option value={fuel.fuelTypeId}>
                          {L(fuel.fuelType, fuel.fuelTypeAr)}
                        </option>
                      ))
                    : null}
                </select>
                {renderFieldError('fuelTypeId')}
              </div>

              <div class="form-group">
                <div class="row">
                  <div class="col-6">
                    <label for="anc-doors">{t('Doors')} <span style={{ color: '#dc3545' }}>*</span></label>
                    <select
                      class="form-control"
                      id="anc-doors"
                      name="doorId"
                      value={CarSaleData.doorId}
                      onChange={handleChange}
                    >
                      <option> - {t('Select Doors Count')} - </option>
                      {sortNum(CarDoor, 'door').map((door, idx) => (
                        <option value={door.doorId}>{door.door}</option>
                      ))}
                    </select>
                    {renderFieldError('doorId')}
                  </div>
                  <div class="col-6">
                    <label for="anc-seats">{t('Seats')} <span style={{ color: '#dc3545' }}>*</span></label>
                    <select
                      class="form-control"
                      id="anc-seats"
                      name="seatId"
                      value={CarSaleData.seatId}
                      onChange={handleChange}
                    >
                      <option> - {t('Select Seats Count')} - </option>
                      {sortNum(CarSeat, 'seat').map((seat, idx) => (
                        <option value={seat.seatId}>{seat.seat}</option>
                      ))}
                    </select>
                    {renderFieldError('seatId')}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="row">
                  <div class="col-6">
                    <label for="anc-interior-color">
                      {t('Interior Color')}{' '}
                      <span style={{ color: '#dc3545' }}>*</span>
                    </label>
                    <select
                      class="form-control"
                      id="anc-interior-color"
                      name="interiorColorId"
                      value={CarSaleData.interiorColorId}
                      onChange={handleChange}
                    >
                      <option value=""> - {t('Select Interior Color')} - </option>
                      {CarColor !== undefined && CarColor.length
                        ? CarColor.map((color, idx) => (
                            <option key={idx} value={color.colorId}>
                              {L(color.color, color.colorAr)}
                            </option>
                          ))
                        : null}
                    </select>
                    {renderFieldError('interiorColorId')}
                  </div>
                  <div class="col-6">
                    <label for="anc-exterior-color">
                      {t('Exterior Color')}{' '}
                      <span style={{ color: '#dc3545' }}>*</span>
                    </label>
                    <select
                      class="form-control"
                      id="anc-exterior-color"
                      name="exteriorColorId"
                      value={CarSaleData.exteriorColorId}
                      onChange={handleChange}
                    >
                      <option value=""> - {t('Select Exterior Color')} - </option>
                      {CarColor !== undefined && CarColor.length
                        ? CarColor.map((color, idx) => (
                            <option key={idx} value={color.colorId}>
                              {L(color.color, color.colorAr)}
                            </option>
                          ))
                        : null}
                    </select>
                    {renderFieldError('exteriorColorId')}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <h5>{t('Safety and Security')}</h5>
                <div className="CarForSale_safety">
                  {CarSafety !== undefined && CarSafety.length
                    ? CarSafety.map((safe, idx) => (
                        <div>
                          <input
                            type="checkbox"
                            // name={idx}
                            id={safe.safetyId}
                            value={safe.safetyId}
                            checked={Safety.includes(safe.safetyId)}
                            onChange={handleSafetyChange}
                          />
                          <label htmlFor={safe.safetyId}>
                            {L(safe.safety, safe.safetyAr)}
                          </label>
                        </div>
                      ))
                    : null}
                </div>
              </div>

              <div class="form-group">
                <h5>{t('Comfort and Convienience')}</h5>
                <div className="CarForSale_safety">
                  {CarComfort !== undefined && CarComfort.length
                    ? CarComfort.map((comf, idx) => (
                        <div>
                          <input
                            type="checkbox"
                            // name={idx}
                            id={comf.comfortId}
                            value={comf.comfortId}
                            checked={Comfort.includes(comf.comfortId)}
                            onChange={handleComfortChange}
                          />
                          <label htmlFor={comf.comfortId}>
                            {L(comf.comfort, comf.comfortAr)}
                          </label>
                        </div>
                      ))
                    : null}
                </div>
              </div>

              <button type="submit" class="btn btn-warning btn-block btn-lg">
                {editId ? t('Update') : t('Post')}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Choose a package and pay to PUBLISH the car for sale. The car record
          is already created at this point but stays unpublished until paid. */}
      <div
        class="modal fade"
        id="carsale-package-modal"
        tabindex="-1"
        aria-labelledby="carsalePackageLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="carsalePackageLabel">
                {t('Choose a package to publish your car')}
              </h5>
            </div>
            <div class="modal-body">
              <p style={{ color: '#777' }}>
                {t(
                  'Your car has been saved. Select a package to publish it on the website.'
                )}
              </p>
              <div class="row">
                {planList && planList.length ? (
                  planList.map((plan) => {
                    const isFree =
                      Number(plan?.amount) === 0 ||
                      String(plan?.advertisementPackId || '')
                        .toUpperCase()
                        .includes('FREE');
                    return (
                      <div
                        class="col-12 col-sm-6 col-md-4 mb-3"
                        key={plan?.advertisementPackId}
                      >
                        <div
                          class="card h-100"
                          style={{ borderRadius: '10px' }}
                        >
                          <div class="card-body text-center">
                            <h5 class="mb-2">{plan?.name}</h5>
                            <div
                              class="mb-2"
                              style={{ fontSize: '20px', fontWeight: 700 }}
                            >
                              {isFree
                                ? t('Free')
                                : `${plan?.currency || 'KWD'} ${plan?.amount}`}
                            </div>
                            <div class="mb-3" style={{ color: '#777' }}>
                              {plan?.duration} {t('days')}
                            </div>
                            <button
                              type="button"
                              class="btn btn-warning btn-block"
                              onClick={() => onChoosePackage(plan)}
                            >
                              {isFree ? t('Publish Free') : t('Select & Pay')}
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div class="col-12 text-center" style={{ color: '#777' }}>
                    {t('No packages available right now.')}
                  </div>
                )}
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                onClick={() => {
                  hidePackageModal();
                  window.location.href = '#/user-cars-for-sale';
                }}
              >
                {t('Do it later')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
